import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { ArchitectureDiagram } from '../components/ArchitectureDiagram';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
export function HomeArchitecture() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-4590" />
      <ArchitectureDiagram data-id="element-4591" />
      <HowItWorksConnections mode="how" data-id="element-4592" />
      <LivesInSlack data-id="element-4593" />
      <ComputerUse data-id="element-4594" />
      <CapabilityGrid data-id="element-4595" />
      <NarrativeSection data-id="element-4596" />
      <ToolComparison data-id="element-4597" />
      <WallOfLove data-id="element-4598" />
      <PricingSection data-id="element-4599" />
      <ClosingCTA data-id="element-4600" />
    </>;
}